import React from 'react';
import styles from "./FeatureSecond.module.css";
import icon from '../../../images/Features/happy-children-playing-playstation-on-sofa--photo-.webp'
import {motion} from 'framer-motion';

const FeatureSecond = ({openModal}) => {
    return (
        <div className={styles.feature_container}>
            <motion.div
                initial={{opacity: 0, x: -200}}
                whileInView={{opacity: 1, x: 0}}
                transition={{duration: 1}}
                viewport={{once: true}}
                className="p-6 bg-blue-500 text-white rounded-lg shadow-lg"
            >
                <div className={styles.feature_row}>
                    <div className={styles.column}>
                        <h2>Порадуйте дітей <span style={{color: 'red'}}>без великих витрат</span>!</h2>
                        <img className={styles.second_img} src={icon} alt="happy-children"/>
                        <h3>Проходьте ігри разом або змагайтеся!</h3>
                        <p>Не хвилюйтесь, якщо консоль набридне дитині, адже її завжди можна повернути.</p>
                        <button onClick={() => openModal()} className={styles.btn}>Отримати консоль</button>
                    </div>
                    <img className={styles.first_img} src={icon} alt="happy-children"/>
                </div>
                </motion.div>
        </div>
);
};

export default FeatureSecond;